import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import InfoTooltip from 'components/shared/InfoTooltip';
import classNames from 'classnames';

const truncate = input =>
  input?.length > 43 ? `${input.substring(0, 43)}...` : input;

const isDisabled = val =>
  classNames('mb-12', {
    'disabled pe-none': val,
  });

const UrlLink = ({
  url,
  adminView,
  videoMeetingOther,
  previewing,
  disabled,
}) => {
  const WithLink = ({ children }) => (
    <a
      className={`z-10 p-0 ${isDisabled(previewing || disabled)}`}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      tabIndex={previewing || disabled ? -1 : 0}
    >
      {children}
    </a>
  );
  const NoLink = ({ children }) => (
    <span className={`z-10 p-0 ${isDisabled(previewing || disabled)}`}>
      {children}
    </span>
  );
  const UrlWrapper = previewing || disabled ? NoLink : WithLink;
  return (
    <UrlWrapper>
      <Text variant={TEXT_VARIANTS.BODY_LINK}>{truncate(url)}</Text>
      {adminView && videoMeetingOther && (
        <InfoTooltip
          tooltip={t(
            'in_person_training.event_overview.video_conference_tooltip',
          )}
          className="ml-4"
        />
      )}
    </UrlWrapper>
  );
};

const SessionDetail = ({
  icon,
  label,
  value,
  isUrl = false,
  adminView,
  videoMeetingOther,
  previewing,
  disabled,
}) =>
  !!value && (
    <tr className="EventSessionDetails-row">
      <td className="EventSessionDetails-cell">
        <div>{icon} </div>
      </td>
      <td className="EventSessionDetails-cell text-wrap">
        <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
          {label}{' '}
          <Text variant={TEXT_VARIANTS.BODY}>
            {isUrl ? (
              <UrlLink
                url={value}
                adminView={adminView}
                videoMeetingOther={videoMeetingOther}
                previewing={previewing}
                disabled={disabled}
              />
            ) : (
              value
            )}
          </Text>
        </Text>
      </td>
    </tr>
  );

export default SessionDetail;
